import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about">
      <h1 className="title">About Me</h1>
      <div className="contentContainer">
        <img className="aboutImage" src="assets/about-image.jpg" alt="Headshot of Kianna" />
        <div className="aboutText">
        <p>
              I'm a researcher and writer with an M.S. in Data Science and Engineering and a B.S. in Economics. I have a background in predictive modeling, machine learning, and web development. 
              </p>
              <p>
              My goal is to ensure that technology, data science, and complex ideas are accessible to diverse communities. As technology grows in its reach, it is important that everyone has a hand in how it shapes our world, and that starts with understanding diverse communities across the globe.
              </p>
        </div>
      </div>
    </section>
  );
};

export default About;
